import { formatDateTimeBR } from '@/shared/utils/date-validator'
import DicomPlusHistorico from '../../../dicom-plus/components/dicom-plus-historico/index.vue'

export default {
  name: 'ModalHistoricoExameGrid',
  components: { DicomPlusHistorico },

  props: {
    historico: {
      type: Array,
      default: () => []
    },
    detalhes: {
      type: Array,
      default: () => []
    },
    dicomPlusId: {
      type: [String, Number],
      default: ''
    }
  },

  data() {
    return {
      itemDetalheFocado: null,
      mostrarDetalhes: false
    }
  },

  methods: {
    formatDate(date) {
      return formatDateTimeBR(date)
    },
    abrirDetalhe(item) {
      this.itemDetalheFocado = item
      this.mostrarDetalhes = true
    },
    fecharDetalhes() {
      this.mostrarDetalhes = false
      this.itemDetalheFocado = null
    },
    formatStatus(status) {
      const statusMap = {
        0: 'Disponível',
        1: 'Utilizado',
        99: 'Cancelado'
      }
      return statusMap[status] || 'Desconhecido'
    },
    formatBoolean(value) {
      if (value === null || value === undefined) return '-'
      return value ? this.$i18n.t('x_plus.yes') : this.$i18n.t('x_plus.no')
    },
    formatHistorySystem(item) {
      return item?.nameSystemOpen || item?.nameSystemUpdate || '-'
    }
  }
}
